import { buildClassName } from '@bluebeam/build-class-name';
import * as React from 'react';
import Navigation from 'components/Navigation';

type ProjectTemplateProps = {
  /**
   * The content of the page.
   */
  children: React.ReactElement;

  /**
   * Additional styling to apply.
   */
  className?: string;

  /**
   * Denotes if the content should be invisible.
   */
  isHidden?: boolean;

  /**
   * Denotes if the page content should have padding or not.
   */
  contentPadding?: string | null;
};

const ProjectTemplate: React.FC<ProjectTemplateProps> = ({
  children,
  className,
  isHidden,
  contentPadding,
}) => (
  <Navigation className={isHidden ? 'hide' : undefined}>
    <div
      className={buildClassName(
        'h-full flex flex-row grow',
        contentPadding || 'p-5',
        className
      )}
    >
      {children}
    </div>
  </Navigation>
);

export default ProjectTemplate;
